// Upload screen component - shown when no images are loaded
import React from 'react';
import { Box, VStack, HStack, Text, Input } from '@chakra-ui/react';
import { Upload, Image as ImageIcon } from 'lucide-react';

interface UploadScreenProps {
  fileInputRef: React.RefObject<HTMLInputElement>;
  isDragging: boolean;
  setIsDragging: (value: boolean) => void;
  handleDrop: (e: React.DragEvent) => void;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const UploadScreen: React.FC<UploadScreenProps> = ({
  fileInputRef,
  isDragging,
  setIsDragging,
  handleDrop,
  handleInputChange,
}) => {
  return (
    <Box minH="100vh" bg="background.primary" py={10} px={4}>
      <VStack maxW="700px" mx="auto" spacing={8}>
        {/* Header */}
        <VStack spacing={2}>
          <HStack spacing={3}>
            <Box p={2} bg="brand.primary.shade" borderRadius="lg">
              <ImageIcon size={28} color="#A71C29" />
            </Box>
            {/* <Text fontSize="2xl" fontWeight="bold" color="text.primary" fontFamily="primary">
              Image Optimizer
            </Text> */}

            <Text color="text.secondary" fontFamily="secondary">
              Compress • Crop • Convert
            </Text>
          </HStack>
        </VStack>

        {/* Upload Box */}
        <Box
          w="full"
          cursor="pointer"
          border="2px dashed"
          borderColor={isDragging ? 'brand.primary.DEFAULT' : 'border.default'}
          borderRadius="xl"
          bg={isDragging ? 'brand.primary.shade' : 'background.secondary'}
          p={16}
          textAlign="center"
          transition="all 0.3s"
          _hover={{ borderColor: 'brand.primary.DEFAULT', bg: 'brand.primary.shade' }}
          onClick={() => fileInputRef.current?.click()}
          onDrop={handleDrop}
          onDragOver={(e) => e.preventDefault()}
          onDragEnter={() => setIsDragging(true)}
          onDragLeave={() => setIsDragging(false)}
        >
          <VStack spacing={4}>
            <Box p={4} borderRadius="full" bg="brand.primary.shade">
              <Upload size={48} color="#A71C29" />
            </Box>
            <Text fontSize="xl" fontWeight="semibold" color="text.primary" fontFamily="primary">
              Drop images or click to upload
            </Text>
            <Text color="text.secondary" fontFamily="secondary">
              Supports JPG, PNG, WebP, GIF • Multiple files allowed
            </Text>
          </VStack>
        </Box>

        <Input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          multiple
          hidden
          onChange={handleInputChange}
        />
      </VStack>
    </Box>
  );
};
